import { render, staticRenderFns } from "./ResultAdditionalInformation.vue?vue&type=template&id=56c61cfb&"
import script from "./ResultAdditionalInformation.vue?vue&type=script&lang=js&"
export * from "./ResultAdditionalInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports